import React, {useState, useEffect} from 'react';
import {Card, Text, Group, Badge, Container, Stack, Title, Anchor} from '@mantine/core';
import api from "../../services/api";
import API_URL from '../../config'
import { Link } from 'react-router-dom';

const ReportList = (props) => {
    const {type, title} = props
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchReportsData = async () => {
        try {
            const response = await api.get(`${API_URL}/powerbi/accessible-reports/${type}`);
            setReports(response.data);
        } catch (err) {
            setError('Erreur lors du chargement des données');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReportsData();
    }, []);
    if (!reports || reports.length === 0) {
        return (
            <Container>
                <Title order={2} align="center" mb="lg">
                    {title}
                </Title>
                <Text align="center">Aucun rapport disponible</Text>
            </Container>
        )
    }

    return (
        <Container>
            <Title order={2} align="center" mb="lg">
                {title}
            </Title>
            <Stack spacing="md">
                {reports.map((report, index) => (
                    <Card shadow="sm" padding="lg" radius="md" withBorder key={index}>
                        <Group position="apart" mb="xs">
                            <Anchor component={Link} to={`/report/${report.id}`} underline>
                                {report.name}
                            </Anchor>
                            <Badge color="blue" variant="light">
                                {report.powerbicode}
                            </Badge>
                        </Group>

                        <Text size="sm" color="dimmed">
                            {report.description}
                        </Text>
                    </Card>
                ))}
            </Stack>
        </Container>
    );
};

export default ReportList;